import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import {
  PrimaryButtonFlexable32,
  SecondaryTextButton48,
} from 'components/Common/MasterComponents'
import LogoIcon from 'components/Common/Icons/Logo/Base'
import LanguageSelector from 'components/Pages/AccountSetup/Header/LanguageSelector'
import breakpoints from 'utils/consts/breakpoints'

const Wrapper = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1168px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
  background: var(--color-white);

  @media screen and ${breakpoints.device.mobile} {
    padding: 0 16px;
  }
`

const Border = styled.div`
  border-bottom: 1px solid var(--color-sw-10);
`

const LanguageWrapper = styled.div`
  height: 32px;
  width: 82px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
`

const LogoLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
`

const LoginBlock = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`

const ButtonLink = styled.a`
  text-decoration: none;
`

const LoginButton = styled(SecondaryTextButton48)`
  font: var(--typography-12-16-semibold);

  @media screen and ${breakpoints.device.mobile} {
    display: none;
  }
`

const Header = () => {
  const { t } = useTranslation()
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const handleAfterSelect = (locale: string) => {
    navigate(`/${locale}/public-captured-wine/${id}`, { replace: true })
  }

  return (
    <Border>
      <Wrapper>
        <LanguageWrapper>
          <LanguageSelector skipMutation onAfterSelect={handleAfterSelect} />
        </LanguageWrapper>

        <LogoLink href='https://worldwinelist.com/'>
          <LogoIcon color={'var(--color-brand-red)'} />
        </LogoLink>

        <LoginBlock>
          <ButtonLink href='/acc/login'>
            <LoginButton>{t('login.login')}</LoginButton>
          </ButtonLink>
          <ButtonLink href='/acc/signup'>
            <PrimaryButtonFlexable32>
              {t('login.signup')}
            </PrimaryButtonFlexable32>
          </ButtonLink>
        </LoginBlock>
      </Wrapper>
    </Border>
  )
}

export default Header
